import { IntlShape } from "react-intl";

import Import from "@mapmycustomers/shared/types/imports/Import";

import { formatRawDate } from "@app/util/formatters";

import ImportHistoryRow from "../type/ImportHistoryRow";

const getSkipFileName = (intl: IntlShape, importHistoryRow: Import | ImportHistoryRow): string =>
  intl.formatMessage(
    {
      id: "imports.skipFile.fileName",
      defaultMessage: "Skip File - {date}",
      description: "Name of Skip file to download",
    },
    {
      date: formatRawDate(importHistoryRow.createdAt, "PPPp", "-"),
    }
  );

export default getSkipFileName;
